import Model from './ModelCustomer'

export default class Order extends Model {
  resource()
  {
    return 'orders'
  }
}